/**
 * StepIndicator.js
 *
 * Visual progress indicator shown at the top of the wizard.
 * Completed steps show a checkmark, current step is highlighted with a pulse ring,
 * future steps are muted. Steps are connected by an animated fill line.
 *
 * Props:
 *   currentStep  — 1-based index of the active step
 *   totalSteps   — total number of steps (default 8)
 *   labels       — array of short Persian step labels
 */

const CheckIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"
        strokeLinecap="round" strokeLinejoin="round" width="14" height="14">
        <polyline points="20 6 9 17 4 12" />
    </svg>
);

export default function StepIndicator({ currentStep, totalSteps = 8, labels = [] }) {
    return (
        <div className="si-wrap" role="navigation" aria-label="مراحل ثبت درخواست">
            {Array.from({ length: totalSteps }, (_, i) => {
                const step = i + 1;
                const done = step < currentStep;
                const active = step === currentStep;
                const future = step > currentStep;

                // connector line fill percentage (between this dot and the next)
                const lineProgress = done ? 100 : active ? 50 : 0;

                return (
                    <div key={step} className="si-item">
                        {/* ── dot ── */}
                        <div
                            className={`si-dot ${done ? 'done' : ''} ${active ? 'active' : ''} ${future ? 'future' : ''}`}
                            aria-current={active ? 'step' : undefined}
                            aria-label={`مرحله ${step}${labels[i] ? ': ' + labels[i] : ''}${done ? ' (تکمیل شده)' : active ? ' (فعال)' : ''}`}
                        >
                            {done ? <CheckIcon /> : <span className="si-dot-num">{step}</span>}
                            {active && <span className="si-pulse" aria-hidden="true" />}
                        </div>

                        {/* ── label ── */}
                        {labels[i] && (
                            <span className={`si-label ${active ? 'active' : ''} ${done ? 'done' : ''}`}>
                                {labels[i]}
                            </span>
                        )}

                        {/* ── connector line (not after last step) ── */}
                        {step < totalSteps && (
                            <div className="si-line" aria-hidden="true">
                                <div
                                    className="si-line-fill"
                                    style={{ width: `${lineProgress}%` }}
                                />
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
}
